import React, { useState } from 'react';

export const CoatingLens = ({ onToggle }) => {
  const [isCoatinChecked, setIsCoatinChecked] = useState(false);

  return (
    <>
      <div className="relative text-center pb-16 power-type-modal">
        <div className="h-full flex items-center align-middle justify-center overflow-y-auto less240">
          <div>
            <div onClick={() => onToggle(2)} class="text-cyan-500 text-sm mb-4 md:absolute cursor-pointer"><i class="fa fa-arrow-left margin-l20 margin-r10"></i> LENS PACKAGE</div>
            <div className="bg-orange-100 rounded-2xl text-orange-400 inline-block mx-auto mb-6 py-1 px-6">Optional</div>
            <div className="border rounded p-9 lg:w-2/3 w-11/12 mx-auto relative lens_coating">
              <label className="cursor-pointer">
                <img src="images/regular_thin.jpg" alt="Coating" />
                <input onClick={() => setIsCoatinChecked(!isCoatinChecked)} type="checkbox" name="" className="absolute opacity-0" />
                <span>coating</span>
              </label>
            </div>
            <div onClick={() => onToggle(3)} class="inline-block mx-auto text-cyan-500 cursor-pointer mt-4 text-sm">SKIP COATING</div>
            <hr className="mt-4" />
          </div>
          <div className="flex justify-between py-4 absolute w-full bottom-0 bg-white">
          <div className="grid place-content-center"><div>Subtotal <span className="text-gray-400">(Frame + Lens):</span> <span className="text-cyan-500">$98</span></div></div>
            <div><button className={isCoatinChecked == true ? "bg-cyan-500 text-white uppercase rounded py-2 px-8" : "bg-gray-200 text-white uppercase rounded py-2 px-8"} onClick={() => onToggle(3)} disabled={!isCoatinChecked}>Apply Coating</button></div>
          </div>
        </div>
      </div>
    </>
  )
}
